module.exports = {
  Required(value) {
    return value ? undefined : 'Required';
  },
  Number(value) {
    let RE = /^-{0,1}\d*\.{0,1}\d+$/;
    return RE.test(value) ? undefined : 'Not a number';
  },
  PositiveNumber(value) {
    let RE = /^-{0,1}\d*\.{0,1}\d+$/;
    if (value) {
      return RE.test(value) && value > 0 ? undefined : 'Must be greater than zero';
    } else {
      return undefined;
    }
  },
  NonNegativeNumber(value) {
    let RE = /^-{0,1}\d*\.{0,1}\d+$/;
    if (value) {
      return RE.test(value) && value >= 0 ? undefined : 'Must be at least zero';
    } else {
      return undefined;
    }
  },
  StringRange15(value) {
    if (value) {
      return value.length >= 2 && value.length <= 15 ? undefined : 'Min Length 2; Max Length 15 characters';
    } else {
      return undefined;
    }
  },
  StringRange50(value) {
    if (value) {
      return value.length >= 2 && value.length <= 50 ? undefined : 'Min Length 2; Max Length 50 characters';
    } else {
      return undefined;
    }
  },
  StringRange150(value) {
    if (value) {
      return value.length >= 2 && value.length <= 150 ? undefined : 'Min Length 2; Max Length 150 characters';
    } else {
      return undefined;
    }
  },
  PhoneNumber(value) {
    let RE = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;
    return RE.test(value) ? undefined : 'Check your phone number';
  },
  Email(value) {
    let RE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return RE.test(value) ? undefined : 'Email is not valid';
  },
  URL(value) {
    let RE = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    return RE.test(value) ? undefined : 'Url is not valid';
  }
};



// WEBPACK FOOTER //
// ./src/components/common/formValidate.js